import { FC, PropsWithChildren } from 'react';
import { PaletteMode, useTheme } from '@mui/material';

import { getOpposite } from '@utils/boolUtils';

import { useLocalStorage } from '../useLocalStorage';

import ToggleThemeContext from './context';

export const ToggleThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    palette: { mode },
  } = useTheme();

  const [_, setPaletteMode] = useLocalStorage<PaletteMode>('theme', 'dark');

  const handleToggleTheme = () => {
    const newMode = getOpposite<PaletteMode>(['light', 'dark'], mode);
    setPaletteMode(newMode);
  };

  return (
    <ToggleThemeContext.Provider value={handleToggleTheme}>{children}</ToggleThemeContext.Provider>
  );
};

export default ToggleThemeProvider;
